import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${(p) => p.isLoading && ``}
  ${(p) =>
    p.isTeaser &&
    `
    ${p.theme.breakpoints.xs.up} {
      flex-direction: column;
      flex-grow: 1;
    }
  `}
`;

export const Item = styled.div`
  ${(p) => p.theme.font.family.condensed}
  text-align: center;
  background-color: ${(p) => p.theme.colors.grey99};
  color: ${(p) => p.theme.colors.vizred};
  line-height: 1.2;
  flex-basis: calc((100% - 2px) / 3);
  padding: var(--margin-vertical-xs, 2px) 0;
  display: flex;
  flex-direction: column;

  ${(p) =>
    p.isTeaser &&
    `
    ${p.theme.breakpoints.xs.up} {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 8px;
      margin-bottom: 1px;
    }
  `}

  ${(p) =>
    p.type === 'confirmed' &&
    `
    background-color: ${p.theme.colors.vizredReduced};
    color: ${p.theme.colors.vizred};
  `}
  ${(p) =>
    p.type === 'recovered' &&
    `
    background-color: ${p.theme.colors.vizgreenReduced};
    color: ${p.theme.colors.vizgreenDark};
  `}
  ${(p) =>
    p.type === 'deaths' &&
    `
    background-color: ${p.theme.colors.vizblackReduced};
    color: ${p.theme.colors.vizblack};
  `}

  transition: color 250ms ease-in-out;
  ${(p) =>
    p.trend === 'trend-none' &&
    `
      display: none;
  `}
  ${(p) =>
    p.trend === 'trend-up' &&
    `
      color: ${p.theme.colors.vizred};
  `}
  ${(p) =>
    p.trend === 'trend-mid' &&
    `
    color: ${p.theme.colors.lightText};
  `}
  ${(p) =>
    p.trend === 'trend-almost-zero' &&
    `
      color: ${p.theme.colors.vizgreen};
  `}
  ${(p) =>
    p.trend === 'trend-zero' &&
    `
      color: ${p.theme.colors.vizgreen};
  `}
  ${(p) =>
    p.trend === 'trend-down' &&
    `
      color: ${p.theme.colors.vizgreenDark};
  `}
`;

export const Number = styled.div`
  font-weight: 700;
  letter-spacing: -1px;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${(p) =>
    p.isSmall &&
    `
    font-size: 17px !important;
  `}
`;

export const Prefix = styled.span`
  font-weight: normal;
  font-size: 13px;
  margin-right: 4px;
`;

export const Label = styled.div`
  font-size: 12px;
`;

export const Source = styled.div`
  ${(p) => p.theme.font.family.condensed}
  color: ${(p) => p.theme.colors.grey50};
  margin: var(--margin-vertical-sm, 4px) var(--margin-horizontal, 16px) 0;
  font-size: 12px;
  letter-spacing: 0.1px;
  text-align: right;

  ${(p) =>
    p.isTeaser &&
    `
    display: none;
  `}
  ${(p) =>
    p.type === 'warning' &&
    `
    color: ${p.theme.colors.vizred};
    text-align: left;
    svg {
      margin-right: 3px;
    }
  `}
`;

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  
  100% {
    background-position: 468px 0; 
  }
`;

export const Placeholder = styled.div`
  background: #f6f7f8;
  background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
  background-repeat: no-repeat;
  background-size: 800px 104px;
  display: block;
  position: relative;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${shimmer};
  animation-timing-function: linear;
`;
